<template>
  <div>
    <v-card>
      <v-row>
        <v-col cols="10">
          <v-card-title>{{ item.title || `${item.type} title` }}</v-card-title>
        </v-col>
        <v-col cols="2 text-align-right">
          <v-btn
            class="mx-2 remove-item"
            fab
            small
            color="btn btn-danger"
            @click="$emit('removeItem', itemIndex, rowIndex)"
          >
            <i class="fa fa-minus"/>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col 
          cols="12" 
          class="pb-0 pt-0">
          <div class="form-check">
            <label class="form-check-label pl-3">
              <input
                v-model="item.isRequired"
                type="checkbox"
                class="form-check-input"
              >
              Is required?
            </label>
          </div>
        </v-col>
      </v-row>
      <v-text-field
        :placeholder="`Enter ${item.type} title`"
        v-model="item.title"
        solo
        class="p-1em pt-0"
        hide-details="true"
      />

      <template v-if="item.type === 'dropdown'">
        <dropdown :item="item"/>
      </template>
      <template v-else-if="item.type === 'checkboxes'">
        <dropdown 
          :item="item" 
          title="Checkboxes settings"/>
      </template>
      <template v-else-if="item.type === 'radio'">
        <dropdown 
          :item="item" 
          title="Radio settings"/>
      </template>
      <template v-else-if="item.type === 'file'">
        <file :item="item"/>
      </template>
      <template v-else>
        <v-row justify="center"/>
      </template>

      <v-card-subtitle>{{ item.type }}</v-card-subtitle>
      <v-card-subtitle
        v-if="item.type === 'file'"
        class="p-right"
      >
        {{ item.value }}
      </v-card-subtitle>
    </v-card>
  </div>
</template>

<script>

import Dropdown from './Dropdown'
import File from './File'

export default {
  name: 'Field',
  components: {
    Dropdown,
    File
  },
  props: ['item', 'itemIndex', 'rowIndex'],
  data() {
    return {
      dialog: false,
    }
  }
}

</script>

<style scoped>
.v-card__subtitle.p-right {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
